import { FilePdfOutlined } from '@ant-design/icons';
import { Col, Collapse, Row } from 'antd';
import "./InvestorInformation.css"
import React from 'react'

const PolicyStatutoryInfo = () => {
  const { Panel } = Collapse
   const policyData = [
    {
      title: "CSR Policy",
      documents: [
        {
          name: "CSR Policy",
          file: "/pdfs/policyStatutoryInfo/CSR Policy.pdf",
        },
      ],
    },
    {
      title: "Nomination and Remuneration Policy",
      documents: [
        {
          name: "Nomination & Remuneration Policy",
          file: "/pdfs/policyStatutoryInfo/Nomination and Remuneration Policy.pdf",
        },
      ],
    },
    {
      title: "Vigil Mechanism Policy",
      documents: [
        {
          name: "Vigil Mechanism Policy",
          file: "/pdfs/policyStatutoryInfo/Vigil Mechanism policy.pdf",
        },
      ],
    },
    {
      title: "Terms & Conditions of Appointment of Independent Directors",
      documents: [
        {
          name: "Terms and conditions of Independent Director",
          file: "/pdfs/policyStatutoryInfo/Terms and conditions of Independent Director.pdf",
        },
      ],
    },
  ];
  return (
    <>
      <Row justify="center" style={{ marginBottom: "30px"}}>
        <Col span={24}>
          <Collapse
            accordion
            bordered={false}
            className="policy-collapse"
          >
            {policyData.map((policy, index) => (
              <Panel
                header={policy.title}
                key={index}
                className="policy-panel"
              >
                <ul className="policy-doc-list" >
                  {policy.documents &&
                    policy.documents.map((doc, i) => (
                      <li key={i} className="policy-doc-item">
                        <a
                          href={doc.file}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="policy-doc-link"
                        >
                          <FilePdfOutlined
                            style={{ color: "#d32029", marginRight: "8px" }}
                          />
                          {doc.name}
                        </a>
                      </li>
                    ))}
                </ul>
              </Panel>
            ))}
          </Collapse>
        </Col>
      </Row>
    </>
  )
}

export default PolicyStatutoryInfo
